import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const BlogArticle = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadArticle = async () => {
      try {
        // First check if this article exists in posts.json
        const postsResponse = await fetch('/content/blog/posts.json');
        const posts = await postsResponse.json();
        const article = posts.find(post => post.slug === slug);
        
        if (!article) {
          setError('Article not found');
          setLoading(false);
          return;
        }

        // Set document title
        document.title = `${article.title} — QuoteTier Blog`;
        
        // Redirect to the static HTML file
        window.location.href = `/blog/${slug}/`;
        
      } catch (err) {
        console.error('Error loading article:', err);
        setError('Failed to load article');
        setLoading(false);
      }
    };

    loadArticle();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="spinner spinner-lg mx-auto mb-4"></div>
          <p className="text-gray-600">Loading article...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
          <p className="text-gray-600 mb-6">Article not found</p>
          <button 
            onClick={() => navigate('/blog')}
            className="bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-colors"
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  return null; // This component redirects, so no render needed
};

export default BlogArticle;
